import {
  AudioLines,
  GalleryHorizontalEnd,
  Images,
  RectangleHorizontal,
  ScrollText,
  Square,
  UserSquare,
  Video,
  type LucideIcon,
} from "lucide-react";

import type { SceneShape } from "@/entities/scene-card/model/types";

/**
 * 场景来源条的图标 —— 2026-07-28。
 *
 * ═══ 为什么不用 SceneShapeGlyph ════════════════════════════════════════════
 * 那个几何图示(三个按比例的空线框)在**卡墙的大卡里**是对的:形制的信息量在比例里,
 * 一套等宽图标会把这一维抹平。但在来源条这个 16~44px 的位置上，它缩完只剩几个灰
 * 线框 —— 用户报的「进来页面上面那个丑」就是它。
 *
 * 更要命的是**不一致**:同一条来源条,追爆蓝图用 ClipboardList、长图模板用
 * LayoutTemplate、产品用 Package,全是实心 lucide 图标,只有场景卡用几何线框。
 * 一条 strip 上两套图形语言,怎么调都别扭。
 *
 * 形制信息不丢:画幅进了规格 chip(`9:16 + 1:1 + 16:9`),比线框更准确可读。
 */
const SHAPE_ICON: Record<SceneShape, LucideIcon> = {
  square: Square, // 1 张方图
  carousel: GalleryHorizontalEnd, // N 张组图(轮播)
  ratios: Images, // 一次三个比例
  long: ScrollText, // 1 条长图(细高)
  wide: RectangleHorizontal, // 1 条宽图(扁宽)
  video: Video, // 1 条视频
  avatar: UserSquare, // 1 条出镜视频(带人像)
  audio: AudioLines, // 1 段音频(无画面)
  article: ScrollText, // 1 篇文章
};

export function sceneOriginIcon(shape: SceneShape): LucideIcon {
  return SHAPE_ICON[shape] ?? Images;
}
